<template>
    <ul class="transactionHistory"  >
      <router-link tag="li" :to="{ name: 'payments.show', params: { bookingId: transaction.payments[0].booking_id, paymentId: transaction.payments[0].id, action: 'view' } }" v-for="transaction in transactionItems" :key="transaction.id" class="transactionHistory_item cursor-pointer" >

        <div class="transactionHistory_sidebar" >
          <div class="transactionHistory_date" >{{ transaction.date | dateTimezone( $user.timezone, $user.date_format_preference, true) }}</div>
          <div class="transactionHistory_paidLabel label label-success">Paid</div>
        </div>

        <div class="transactionHistory_main">

          <div class="transactionHistory_header">
            <h3>{{ transaction.info.name }}</h3>
            <div class="transactionHistory_price" >{{ transaction.amount | currency }}</div>
          </div>

          <div>{{ transaction.info.description }}</div>

          <div v-if="transaction.receipt_url" class="transactionHistory_receiptLink" >
            <a :href="transaction.receipt_url" target="_blank" >
              <i class="fa fa-file-alt"></i>
              View Receipt
            </a>
          </div>

        </div>

      </router-link>
    </ul>
</template>

<script>
export default {

  props: {
    transactions: {
      type: Array,
      required: true
    }
  },

  computed: {
    transactionItems () {
      return this.transactions.map(item => {
        item.info = this.transactionInfo(item.payments)
        item.date = item.payments[0].paid_date
        return item
      })
    }
  },

  methods: {
    transactionInfo (payments) {
      if (payments.length > 1) {
        return {
          name: 'Full Payment',
          description: 'Your full payment has been received and you have no further payments to make.'
        }
      }

      const payment = payments[0]

      if (payment.type === 'final') {
        return {
          name: 'Final Payment',
          description: 'Your final payment has been received and you have no further payments to make.'
        }
      } else if (payment.type === 'deposit') {
        return {
          name: 'Deposit',
          description: 'Your 50% deposit has been received.'
        }
      } else if (payment.type === 'full') {
        return {
          name: 'Full Payment',
          description: 'Your full payment has been received and you have no further payments to make.'
        }
      }
    }
  }

}
</script>
